import { useState, useMemo } from 'react';
import { AppCategory } from '../types/appIntegration.types';
import { getAppsByCategory, getAvailableCategories } from '../utils/appCategories.utils';
import { useGetAllIntegrations } from './useGetAllIntegrations';

export const useAppGrid = () => {
  const { integrations, isLoading } = useGetAllIntegrations();

  const [selectedCategory, setSelectedCategory] = useState<AppCategory | null>(null);

  const categories = useMemo(
    () => getAvailableCategories(integrations),
    [integrations]
  );

  const visibleCategories = useMemo(
    () => (selectedCategory ? [selectedCategory] : categories),
    [selectedCategory, categories]
  );

  const getAppsForCategory = (category: AppCategory) =>
    getAppsByCategory(category, integrations);

  return {
    integrations,
    isLoading,
    selectedCategory,
    setSelectedCategory,
    categories,
    visibleCategories,
    getAppsForCategory,
  };
};